import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b25ecb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StatisticalEmp" }
const _hoisted_2 = { class: "statitiscal" }
const _hoisted_3 = { class: "pv" }
const _hoisted_4 = { class: "uv" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { toDay, secondToMin } from '@/utils/date-format'
import { useRouter } from 'vue-router'
import { queryStatistical } from '@/service/main/promotion/statitiscal'
import { ref } from 'vue'

import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticalEmp',
  setup(__props) {

const store = useStore()

const userInfo = store.state.login.userInfo

const queryParam = {
  accessTime: [toDay(), toDay()]
}
store.commit('system/changeQueyryInfo', queryParam)

const getEmp = () => {
  const index = searchFormConfig.formItems.findIndex(
    (item) => item.field === 'empIds'
  )
  if (index > -1) {
    searchFormConfig.formItems.splice(index, 1)
  }
  if (userInfo.isManager == '1') {
    const options = store.state.login.depts
    searchFormConfig.formItems.push({
      field: 'empIds',
      type: 'cascader',
      label: '员工',
      placeholder: '请选择员工',
      options: options,
      otherOptions: {
        'show-all-levels': false,
        clearable: true,
        props: {
          multiple: true,
          value: 'id',
          label: 'name',
          children: 'emps',
          emitPath: false
        }
      }
    })
  }
}

getEmp()

const router = useRouter()

const handleEmp = (item: any) => {
  router.push({
    path: '/main/promotion/access',
    query: {
      empIds: item.empId,
      accessTime: store.state.system.queryInfo.accessTime
    }
  })
}

const resetCb = () => {
  return queryParam
}

const statitiscal = ref({ pv: 0, uv: 0 })

const searchCb = async (item: any) => {
  statitiscal.value = await queryStatistical(item)
}

searchCb({ ...queryParam })

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(
  resetCb,
  searchCb
)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("总访问次数(pv): "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.pv), 1)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createTextVNode("客户数量(uv): "),
        _createElementVNode("em", null, _toDisplayString(statitiscal.value.uv), 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "promotionStatisticalEmp",
      onRowClick: handleEmp,
      onSortChange: handleSortChange
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToMin)(scope.row.duration)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})